export interface FiscalMemorySelectionOption {
  id: number
  isActive?: boolean
  isDefault?: boolean
  isEnabled?: boolean
}

export const resolveFiscalMemorySelection = <T extends FiscalMemorySelectionOption>(
  options: T[] = [],
  currentId?: number,
  preferProduction = true
) => {
  const current = options.find((option) => option.id === currentId)
  if (current) {
    return current
  }

  const enabled = options.filter((option) => option.isEnabled !== false)
  const preferredEnvironment = enabled.filter(
    (option) => (option.isActive !== false) === preferProduction
  )

  return (
    preferredEnvironment.find((option) => option.isDefault) ||
    (preferredEnvironment.length === 1 ? preferredEnvironment[0] : undefined) ||
    enabled.find((option) => option.isDefault) ||
    (enabled.length === 1 ? enabled[0] : undefined)
  )
}
